import { Route, Routes } from 'react-router';

import { Menu } from 'ibnsina-ui';

import AuthLayout from './AuthLayout';
import PrivateLayout from './PrivateLayout';

import { commonRoutes, privateRoutes, authRoutes } from 'routes';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    selectBusinessType,
    selectSupplierHaveCustomizeReports,
    selectSupplierId,
    selectUser,
} from 'features/auth/slice';

import homeIcon from 'ui/assets/images/menu/home.svg';
import reportsIcon from 'ui/assets/images/menu/show-chart.svg';
import salesAndStockIcon from 'ui/assets/images/menu/sales-and-stock.svg';
import salesByClientIcon from 'ui/assets/images/menu/sales-by-client.svg';
import salesByBrickIcon from 'ui/assets/images/menu/sales-by-brick.svg';
import teamsIcon from 'ui/assets/images/menu/teams.svg';
import customizedIcon from 'ui/assets/images/menu/customize-reports.svg';

import HomeSVG from 'ui/assets/images/home/dashboard.svg';

import { useEffect } from 'react';
import { setHeader } from 'features/layout/slice';
import { ItemsType } from 'ibnsina-ui/dist/components/Menu/types';

const PrivateRoute = () => {
    const businessType = useAppSelector(selectBusinessType);

    const checkCustomizeReports = useAppSelector(
        selectSupplierHaveCustomizeReports,
    );

    let reports: ItemsType[] = [];

    switch (businessType) {
        case 10:
            reports = [
                {
                    title: 'Reports',
                    icon: reportsIcon,
                    isParent: true,
                    items: checkCustomizeReports
                        ? [
                              {
                                  url: 'report/sas',
                                  title: 'Sales & Stock',
                                  icon: salesAndStockIcon,
                              },
                              {
                                  url: 'report/sbc',
                                  title: 'Sales by Client',
                                  icon: salesByClientIcon,
                              },
                              {
                                  url: 'report/sbb',
                                  title: 'Sales by Brick',
                                  icon: salesByBrickIcon,
                              },
                              {
                                  url: 'customized-reports',
                                  title: 'Customized',
                                  icon: customizedIcon,
                              },
                          ]
                        : [
                              {
                                  url: 'report/sas',
                                  title: 'Sales & Stock',
                                  icon: salesAndStockIcon,
                              },
                              {
                                  url: 'report/sbc',
                                  title: 'Sales by Client',
                                  icon: salesByClientIcon,
                              },
                              {
                                  url: 'report/sbb',
                                  title: 'Sales by Brick',
                                  icon: salesByBrickIcon,
                              },
                          ],
                },
            ];
            break;
        case 20:
            reports = [
                {
                    title: 'Reports',
                    icon: reportsIcon,
                    isParent: true,
                    items: [
                        {
                            url: 'tender',
                            title: 'Tenders',
                            icon: salesByClientIcon,
                        },
                    ],
                },
            ];
            break;
    }

    const menu = (
        <Menu
            items={[
                {
                    title: 'Home',
                    url: '/',
                    icon: homeIcon,
                },
                ...reports,
                {
                    title: 'Teams',
                    url: '/pokacc',
                    icon: teamsIcon,
                },
            ]}
        />
    );

    return (
        <PrivateLayout menu={menu}>
            <Routes>
                {[privateRoutes, ...commonRoutes].map(
                    (privateRoute) => privateRoute,
                )}
            </Routes>
        </PrivateLayout>
    );
};

const AuthRoute = () => {
    return (
        <AuthLayout>
            <Routes>
                {[authRoutes, ...commonRoutes].map((authRoute) => authRoute)}
            </Routes>
        </AuthLayout>
    );
};

export default function LayoutManager() {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);
    const supplier = useAppSelector(selectSupplierId);

    useEffect(() => {
        dispatch(
            setHeader({
                icon: HomeSVG,
                title: 'Page Title',
                user: {
                    id: '1',
                    firstName: '',
                    lastName: '',
                    avatar: '',
                },
                layout: 'default' as const,
                theme: 'default' as const,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Routes>
            <Route
                path="*"
                element={user && supplier ? <PrivateRoute /> : <AuthRoute />}
            />
            {[commonRoutes].map((commonRoute) => commonRoute)}
        </Routes>
    );
}
